import { Environment } from "./environment.model";

export const environment: Environment = {
  production: false,
  mapboxApiKey: 'pk.eyJ1IjoibmF0YXBwIiwiYSI6ImNqZHg1MXZndDNxM2UzM3FwdnRsdW96cWIifQ.szIwfw6q7QTADsLCQXCKiw',
  apiUrl: '/.netlify/functions',
  demo: true
} as const;
